export default {
  'AdminUser': {
    collection: 'adminUsers',
    element: 'adminUser',
    label: 'name',
    enum: {
    }
  },
  'AdminUsersRole': {
    collection: 'adminUsersRoles',
    element: 'adminUsersRole',
    label: 'id',
    enum: {
    }
  },
  'Role': {
    collection: 'roles',
    element: 'role',
    label: 'name',
    enum: {
      kinds: [
        'super',
        'application',
        'custom',
      ],
    }
  },
  'Application': {
    collection: 'applications',
    element: 'application',
    label: 'name',
    enum: {
    }
  },
  'ActiveStorage::Attachment': {
    collection: 'activeStorage/attachments',
    element: 'activeStorage/attachment',
    label: 'name',
    enum: {
    }
  },
  'Banner': {
    collection: 'banners',
    element: 'banner',
    label: 'id',
    enum: {
      page_positions: [
        'event',
      ],
      kinds: [
        'web_link',
        'image',
        'mp_link',
      ],
    }
  },
  'User': {
    collection: 'users',
    element: 'user',
    label: 'screen_name',
    enum: {
      genders: [
        'unknown',
        'male',
        'female',
      ],
    }
  },
  'Profile': {
    collection: 'profiles',
    element: 'profile',
    label: 'name',
    enum: {
      genders: [
        'unknown',
        'male',
        'female',
      ],
    }
  },
  'Account': {
    collection: 'accounts',
    element: 'account',
    label: 'name',
    enum: {
      statuses: [
        'pending',
        'approved',
        'rejected',
      ],
      risk_assessment_levels: [
        'C1',
        'C2',
        'C3',
        'C4',
        'C5',
      ],
      kinds: [
        'internal',
        'external',
      ],
      account_statuses: [
        'visitor',
        'holder',
        'history_holder',
      ],
    }
  },
  'AccountFund': {
    collection: 'accountFunds',
    element: 'accountFund',
    label: 'id',
    enum: {
    }
  },
  'Fund': {
    collection: 'funds',
    element: 'fund',
    label: 'short_name',
    enum: {
      visibilities: [
        'holder',
        'holder_and_visitor',
        'invisible',
      ],
      risk_levels: [
        'R1',
        'R2',
        'R3',
        'R4',
        'R5',
      ],
    }
  },
  'FeeRate': {
    collection: 'feeRates',
    element: 'feeRate',
    label: 'id',
    enum: {
    }
  },
  'Management': {
    collection: 'managements',
    element: 'management',
    label: 'id',
    enum: {
    }
  },
  'TradeRule': {
    collection: 'tradeRules',
    element: 'tradeRule',
    label: 'name',
    enum: {
    }
  },
  'RevenueDatum': {
    collection: 'revenueData',
    element: 'revenueDatum',
    label: 'id',
    enum: {
    }
  },
  'FundValue': {
    collection: 'fundValues',
    element: 'fundValue',
    label: 'id',
    enum: {
    }
  },
  'ActiveStorage::Blob': {
    collection: 'activeStorage/blobs',
    element: 'activeStorage/blob',
    label: 'id',
    enum: {
    }
  },
  'ActsAsTaggableOn::Tag': {
    collection: 'actsAsTaggableOn/tags',
    element: 'actsAsTaggableOn/tag',
    label: 'name',
    enum: {
    }
  },
  'Page': {
    collection: 'pages',
    element: 'page',
    label: 'title',
    enum: {
    }
  },
  'PresetPage': {
    collection: 'presetPages',
    element: 'presetPage',
    label: 'title',
    enum: {
    }
  },
  'StaticPage': {
    collection: 'staticPages',
    element: 'staticPage',
    label: 'title',
    enum: {
    }
  },
  'CustomPage': {
    collection: 'customPages',
    element: 'customPage',
    label: 'title',
    enum: {
    }
  },
  'HotWord': {
    collection: 'hotWords',
    element: 'hotWord',
    label: 'name',
    enum: {
    }
  },
  'Announcement': {
    collection: 'announcements',
    element: 'announcement',
    label: 'title',
    enum: {
      content_types: [
        'richtext',
        'markdown',
      ],
    }
  },
  'MonthlyReport': {
    collection: 'monthlyReports',
    element: 'monthlyReport',
    label: 'title',
    enum: {
      content_types: [
        'richtext',
        'markdown',
      ],
    }
  },
  'CustodianMonthlyReport': {
    collection: 'custodianMonthlyReports',
    element: 'custodianMonthlyReport',
    label: 'title',
    enum: {
      content_types: [
        'richtext',
        'markdown',
      ],
    }
  },
  'Trade': {
    collection: 'trades',
    element: 'trade',
    label: 'name',
    enum: {
      states: [
        'pending',
        'confirmed',
      ],
    }
  },
  'VideoRecord': {
    collection: 'videoRecords',
    element: 'videoRecord',
    label: 'id',
    enum: {
      statuses: [
        'pending',
        'auditing',
        'finished',
        'rejected',
      ],
    }
  },
  'TradeApplyRecord': {
    collection: 'tradeApplyRecords',
    element: 'tradeApplyRecord',
    label: 'id',
    enum: {
      states: [
        'pending',
        'approved',
        'rejected',
      ],
    }
  },
  'RiskAssessment': {
    collection: 'riskAssessments',
    element: 'riskAssessment',
    label: 'name',
    enum: {
      kinds: [
        'personal',
        'company',
      ],
      states: [
        'draft',
        'published',
        'closed',
      ],
    }
  },
  'RiskAssessmentQuestion': {
    collection: 'riskAssessmentQuestions',
    element: 'riskAssessmentQuestion',
    label: 'id',
    enum: {
      kinds: [
        'single_choice',
        'multiple_choice',
      ],
    }
  },
  'RiskAssessmentOption': {
    collection: 'riskAssessmentOptions',
    element: 'riskAssessmentOption',
    label: 'id',
    enum: {
    }
  },
  'RiskAssessmentResult': {
    collection: 'riskAssessmentResults',
    element: 'riskAssessmentResult',
    label: 'id',
    enum: {
      risk_assessment_levels: [
        'C1',
        'C2',
        'C3',
        'C4',
        'C5',
      ],
    }
  },
  'RiskAssessmentAnswer': {
    collection: 'riskAssessmentAnswers',
    element: 'riskAssessmentAnswer',
    label: 'id',
    enum: {
    }
  },
  'AllotTrade': {
    collection: 'allotTrades',
    element: 'allotTrade',
    label: 'name',
    enum: {
      states: [
        'pending',
        'confirmed',
      ],
    }
  },
  'RedeemTrade': {
    collection: 'redeemTrades',
    element: 'redeemTrade',
    label: 'name',
    enum: {
      states: [
        'pending',
        'confirmed',
      ],
    }
  },
  'AchievementPayTrade': {
    collection: 'achievementPayTrades',
    element: 'achievementPayTrade',
    label: 'name',
    enum: {
      states: [
        'pending',
        'confirmed',
      ],
    }
  },
  'CashDividendTrade': {
    collection: 'cashDividendTrades',
    element: 'cashDividendTrade',
    label: 'name',
    enum: {
      states: [
        'pending',
        'confirmed',
      ],
    }
  },
  'DividendReinvestmentTrade': {
    collection: 'dividendReinvestmentTrades',
    element: 'dividendReinvestmentTrade',
    label: 'name',
    enum: {
      states: [
        'pending',
        'confirmed',
      ],
    }
  },
  'AllotTradeApplyRecord': {
    collection: 'allotTradeApplyRecords',
    element: 'allotTradeApplyRecord',
    label: 'id',
    enum: {
      states: [
        'pending',
        'approved',
        'rejected',
      ],
    }
  },
  'RedeemTradeApplyRecord': {
    collection: 'redeemTradeApplyRecords',
    element: 'redeemTradeApplyRecord',
    label: 'id',
    enum: {
      states: [
        'pending',
        'approved',
        'rejected',
      ],
    }
  },
  'PersonalAccount': {
    collection: 'personalAccounts',
    element: 'personalAccount',
    label: 'name',
    enum: {
      statuses: [
        'pending',
        'approved',
        'rejected',
      ],
      risk_assessment_levels: [
        'C1',
        'C2',
        'C3',
        'C4',
        'C5',
      ],
      kinds: [
        'internal',
        'external',
      ],
      account_statuses: [
        'visitor',
        'holder',
        'history_holder',
      ],
    }
  },
  'CompanyAccount': {
    collection: 'companyAccounts',
    element: 'companyAccount',
    label: 'name',
    enum: {
      statuses: [
        'pending',
        'approved',
        'rejected',
      ],
      risk_assessment_levels: [
        'C1',
        'C2',
        'C3',
        'C4',
        'C5',
      ],
      kinds: [
        'internal',
        'external',
      ],
      account_statuses: [
        'visitor',
        'holder',
        'history_holder',
      ],
    }
  },
  'ProductAccount': {
    collection: 'productAccounts',
    element: 'productAccount',
    label: 'name',
    enum: {
      statuses: [
        'pending',
        'approved',
        'rejected',
      ],
      risk_assessment_levels: [
        'C1',
        'C2',
        'C3',
        'C4',
        'C5',
      ],
      kinds: [
        'internal',
        'external',
      ],
      account_statuses: [
        'visitor',
        'holder',
        'history_holder',
      ],
    }
  },
  'AgentAccount': {
    collection: 'agentAccounts',
    element: 'agentAccount',
    label: 'name',
    enum: {
      statuses: [
        'pending',
        'approved',
        'rejected',
      ],
      risk_assessment_levels: [
        'C1',
        'C2',
        'C3',
        'C4',
        'C5',
      ],
      kinds: [
        'internal',
        'external',
      ],
      account_statuses: [
        'visitor',
        'holder',
        'history_holder',
      ],
    }
  },
}
